import type { IKpiRepository, KpiListOptions } from '../repositories/IKpiRepository.js';
import type { KpiEntity } from '../entities/KpiEntity.js';

interface Deps { kpiRepository: IKpiRepository; }
export function createListKpisUseCase({ kpiRepository }: Deps) {
  return async function listKpis(options?: KpiListOptions): Promise<{ data: KpiEntity[]; total: number }> {
    return kpiRepository.list(options);
  };
}
